interface TestimonialCardProps {
  name: string;
  trade: string;
  location: string;
  rating: number;
  image: string;
  quote: string;
  jobsCompleted: number;
  timeUsing: string;
}

export default function TestimonialCard({
  name,
  trade,
  location,
  rating,
  image,
  quote,
  jobsCompleted,
  timeUsing
}: TestimonialCardProps) {
  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all hover:-translate-y-1">
      {/* Rating Stars */}
      <div className="flex gap-1 mb-4">
        {[...Array(rating)].map((_, i) => (
          <i key={i} className="ri-star-fill text-xl text-yellow-400"></i>
        ))}
      </div>

      {/* Quote */}
      <p className="text-gray-700 text-base leading-relaxed mb-6">
        "{quote}"
      </p>

      {/* Author Info */}
      <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0 bg-gray-100">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-gray-900 text-base">{name}</div>
          <div className="text-sm text-gray-600">{trade}</div>
          <div className="text-xs text-gray-500 flex items-center gap-1 mt-1">
            <i className="ri-map-pin-line"></i>
            {location}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="flex gap-4 mt-4 pt-4 border-t border-gray-100">
        <div className="flex-1">
          <div className="text-xs text-gray-500 mb-1">Jobs Completed</div>
          <div className="font-semibold text-gray-900">{jobsCompleted}</div>
        </div>
        <div className="flex-1">
          <div className="text-xs text-gray-500 mb-1">Using For</div>
          <div className="font-semibold text-gray-900">{timeUsing}</div>
        </div>
      </div>
    </div>
  );
}